var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F923(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#286699",
    d: "M20.9 55.749c1.22-1.033-2.861-12.112-3.98-13.081-.781-.672-4.402-.295-5.65.742-4.158 3.449-.328 13.03 4.459 14.251 1.368.352 4.122-1.025 5.171-1.912z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2C1C0",
    d: "M15.359 59.735c1.34-1.242-3.826-15.397-5.146-16.673-.921-.885-5.021-.578-6.392.668-4.568 4.154.244 16.404 5.742 18.174 1.581.506 4.645-1.099 5.796-2.169z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M16.075 59.491c1.13-1.172-3.993-15.341-5.206-16.649-.848-.912-4.454-.771-5.615.404-3.864 3.912.872 16.191 5.795 18.154 1.41.563 4.054-.9 5.026-1.909z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3383C4",
    d: "M18.976 58.044c1.483-1.254-3.479-14.726-4.842-15.901-.949-.822-5.352-.357-6.869.9-5.06 4.197-.396 15.845 5.42 17.332 1.67.428 5.014-1.251 6.291-2.331z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M18.171 56.509c.158-.67-3.715-11.819-4.301-12.972-.406-.801-1.495-1.281-1.659-.613-.554 2.221 2.892 11.931 4.726 14.159.523.639 1.098.002 1.234-.574z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.414 57.106c.158-.67-3.714-11.821-4.299-12.972-.408-.801-1.495-1.283-1.66-.615-.555 2.225 2.893 11.935 4.725 14.163.523.637 1.097.001 1.234-.576z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 38.001,
    cy: 34,
    r: 23.999
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M35.649 47.971c.416-.32.346-.889.346-1.51V21.539c0-.619.07-1.188-.346-1.51-3.989-3.087-15.65.545-15.65 13.971 0 13.427 11.662 17.059 15.65 13.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C3526",
    d: "M29.806 35.455c.011-.457-.422-1.16-1.565-.904-.578.13-1.277.941-2.211.941-1.896 0-1.896-2.98 0-2.98.934 0 1.633.808 2.211.938 1.145.258 1.576-.444 1.565-.904-.033-1.239-1.39-3.274-3.685-3.274-2.578 0-4.67 2.118-4.67 4.73 0 2.611 2.092 4.73 4.67 4.73 2.296-.002 3.652-2.038 3.685-3.277z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF717F",
    d: "M22.667 27.912c-.767 1.759-1.215 3.79-1.215 6.088 0 2.3.448 4.329 1.215 6.089.824-1.698 1.33-3.72 1.33-6.089 0-2.37-.504-4.39-1.33-6.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M34 45.781V22.218c0-1.617-3-1.617-3-.041v23.647c0 1.575 3 1.575 3-.043z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.666 31.221c4.089-1.487 6.135-3.728 6.135-5.968 0-2.24-2.046-4.48-6.135-5.966-.412-.147-1.155.619-.751 1.003 1.521 1.44 2.127 3.166 2.127 4.963 0 1.799-.605 3.524-2.127 4.965-.404.383.339 1.151.751 1.003zM40.666 48.717c4.089-1.488 6.135-3.729 6.135-5.969 0-2.242-2.046-4.48-6.135-5.969-.412-.146-1.155.619-.751 1.004 1.521 1.441 2.127 3.164 2.127 4.965 0 1.799-.605 3.521-2.127 4.965-.404.383.339 1.15.751 1.004z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#286699",
    d: "M18.702 8.17c-1.767-.458-9.4 10.664-9.562 12.346-.113 1.172 2.631 4.297 4.422 4.777 5.961 1.598 12.359-8.299 10.339-13.565-.577-1.509-3.677-3.165-5.199-3.558z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3383C4",
    d: "M15.832 3.902C13.685 3.347 4.404 16.868 4.205 18.913c-.139 1.428 3.201 5.228 5.377 5.808 7.25 1.945 15.029-10.091 12.574-16.495-.706-1.835-4.473-3.849-6.324-4.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2C1C0",
    d: "M14.466 2.298C12.709 2.08 2.87 16.2 2.409 18.166c-.319 1.37 1.993 4.492 3.768 4.736 5.915.816 14.262-11.685 13.073-17.402-.339-1.639-3.274-3.01-4.784-3.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M14.054 2C12.463 1.898 2.591 16 2.049 17.9c-.377 1.332 1.539 4.17 3.149 4.294 5.354.408 13.76-12.049 13.029-17.433-.208-1.543-2.805-2.672-4.173-2.761z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F923);
export default __webpack_public_path__ + "static/media/1f923.5a464edcbe2114c69fa87987c0693e14.svg";
export { ForwardRef as ReactComponent };